var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgResearchContentPlanner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9652 2.24692C13.4635 1.67764 14.2277 1.41744 14.9698 1.56434L22.696 3.09363C23.4382 3.24054 24.0456 3.77222 24.2895 4.48841L26.8282 11.9441C27.072 12.6603 26.9153 13.4522 26.417 14.0215L21.2295 19.9479C20.7312 20.5172 19.967 20.7774 19.2249 20.6305L11.4987 19.1012C10.7565 18.9543 10.1491 18.4226 9.90521 17.7064L7.36652 10.2507C7.12265 9.53452 7.2794 8.74264 7.7777 8.17336L12.9652 2.24692Z",
    fill: "#EAE7FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2883 5.41195C10.1785 5.41195 6.83728 8.75318 6.83728 12.8629C6.83728 14.7453 7.54316 16.5335 8.84517 17.9296C9.56665 18.6982 9.97454 19.6864 9.97454 20.7061V22.2747C9.97454 24.659 11.904 26.5884 14.2883 26.5884C16.6725 26.5884 18.602 24.659 18.602 22.2747V20.7061C18.602 19.6864 19.0099 18.6982 19.7472 17.9138C21.0334 16.5334 21.7393 14.7453 21.7393 12.8629C21.7393 8.75309 18.398 5.41195 14.2883 5.41195ZM16.2491 22.2747C16.2491 23.357 15.3705 24.2355 14.2883 24.2355C13.206 24.2355 12.3275 23.357 12.3275 22.2747V21.8826H16.2491V22.2747ZM18.0372 16.2982C17.1587 17.2236 16.5939 18.3375 16.3588 19.5297H15.4647V14.4317H13.1118V19.5297H12.2177C11.9824 18.3375 11.4176 17.2239 10.5549 16.314C9.67655 15.3728 9.19023 14.1337 9.19023 12.863C9.19023 10.0551 11.4805 7.76499 14.2883 7.76499C17.096 7.76499 19.3863 10.0551 19.3863 12.863C19.3863 14.1337 18.9 15.3728 18.0372 16.2982Z",
    fill: "#B290FB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearchContentPlanner);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;